/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Converting the instrumentation scope object to a unique identifier string.
 * @param scope - The instrumentation scope to convert
 * @returns A unique string identifier for the scope
 */
export function getInstrumentationScopeKey(scope) {
    return `${scope.name}@${scope.version || ''}:${scope.schemaUrl || ''}`;
}
//# sourceMappingURL=utils.js.map